import React, { useState, useRef, useEffect } from "react";
import Markdown from "react-markdown";
import './App.css'
import { Provider, ErrorBoundary, LEVEL_WARN } from '@rollbar/react'; // Provider imports 'rollbar'

const recipeServer = process.env.NODE_ENV !== 'production' ? 'http://localhost:3001' : 'https://shy-fire-4079.fly.dev';

const rollbarConfig = {
  accessToken: '08e30e14b64344e1bd8e495b68117771',
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: process.env.NODE_ENV,
  server: {
    code_version: "0.1.1"
  },
  enabled: ('production' === process.env.NODE_ENV)
};

const ErrorDisplay = ({ error, resetError }) => ( // <-- props passed to fallbackUI component
  <div>
    <h2>Oops!</h2>
    <p>Something went wrong. We've been alerted.</p>
    <p><button onClick={() => window.location.reload(false)}>Click to reload!</button></p>
    <p className="tiny">{process.env.NODE_ENV} - v{rollbarConfig.server.code_version} - Rollbar {rollbarConfig.enabled ? 'ENABLED': 'DISABLED'}</p>
  </div>
);

function TestError() {
  const a = null;
  return a.hello();
}

const App = () => {
  const [recipe, setRecipe] = useState("");
  const [image, setImage] = useState("");
  const [step, setStep] = useState(0);
  const [flavor, setFlavor] = useState("");
  const myRef = useRef(null);

  const flavors = {
    bell: 'Lemon-Lime',
    berz: 'Raspberry',
    befl: 'Flavorless'
  };

  useEffect(() => {
    myRef.current.scrollIntoView();
  }, [step]);

  const getRecipe = (flavor) => {
    console.log(`what up: ${flavor}`);

    setFlavor(flavors[flavor]);

    setStep(1);

    fetch(`${recipeServer}/recipe/${flavor}`)
    .then(res => res.json())
    .then(
      (result) => {
        console.log(result);
        setRecipe(result.recipe);
        setImage(result.image);
        setStep(2);
      },
      // Note: it's important to handle errors here
      // instead of a catch() block so that we don't swallow
      // exceptions from actual bugs in components.
      (error) => {
        console.log(error);
        setRecipe(`***Try again later***\n\nError: ${error}`);
        setStep(2);
        // var error = new Error(error);
        throw error;
      }
    )

  };

  return (
    <Provider config={rollbarConfig}>
      <ErrorBoundary level={LEVEL_WARN} fallbackUI={ErrorDisplay}>
        <div className="App">
          <header className="App-header">
            <h2>AI Generated Good Feels Beverage Enhancer Recipes</h2>
            <p>* Recipes generated by this page are temporary. If you would like to save this recipe consider printing, screenshotting or saving to PDF.</p>
          </header>
          <div ref={myRef}>
            <div className="App-buttons-container" style={{display: step === 0 ? 'block' : 'none'}}>
              <h3>First choose your flavor</h3>
              <div className="App-buttons">
                <button type="button" onClick={() => getRecipe('bell')}>
                  <img src="http://good-feels-recipes.s3.amazonaws.com/GF_LemonLime_Front-trimmy-center-opt.jpg" alt="Lemon-Lime Beverage Enhancer" />
                </button>
                <button type="button" onClick={() => getRecipe('berz')}>
                  <img src="http://good-feels-recipes.s3.amazonaws.com/GF_Raspberry_Front-trimmy-center-opt.jpg" alt="Raspberry Beverage Enhancer" />
                </button>
                <button type="button" onClick={() => getRecipe('befl')}>
                  <img src="http://good-feels-recipes.s3.amazonaws.com/GF_Flavorless_Front-trimmy-center-opt.jpg" alt="Flavorless Beverage Enhancer" />
                </button>
              </div>
            </div>
            <div className="App-loading" style={{display: step === 1 ? 'block' : 'none' }}>
              <h3>Generating a {flavor} recipe!</h3>
              <img src="http://good-feels-recipes.s3.amazonaws.com/loading.gif" alt="loading..."/>
            </div>
            <div className="App-recipe" style={{display: step === 2 ? 'grid' : 'none' }}>
              <img src={image} alt="Recipe image" />
              <div>
                <Markdown>{recipe}</Markdown>
                <button type="button" onClick={() => setStep(0)}>Start Over</button>
              </div>
            </div>
          </div>
        </div>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
